export const EXPIRY_TIME = 2 * 60 * 60 * 1000 // 2 hrs


export const EYE_TEST_ID = "a0U4W00000MPdRPUA1"
export const CONTACT_LENSES_ID = "a0U4W00000MPdRUUA1"


export const BRIDGE_URL = (endpoint, auth = false) => {
    if(auth) return `${process.env.REACT_APP_BACKEND_URL}/index.php?endpoint=${endpoint}&auth=${auth}`
    return `${process.env.REACT_APP_BACKEND_URL}/index.php?endpoint=${endpoint}`
}